import { PictureInPicture2 } from 'lucide-react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { usePopout } from '../state/popout';
import { useVoice } from '../state/voice';
import { CallStage } from './Call';
import { useChannels } from './Sidebar';

/** Renders the call into the pop-out window while it is open; the main window shows the chat. */
export function PopoutCall() {
  const win = usePopout((s) => s.win);
  const channelId = useVoice((s) => s.channelId);
  const connected = useVoice((s) => s.room !== null);
  const { data: channels } = useChannels();

  // The window goes away with the call.
  useEffect(() => {
    if (win && !channelId) usePopout.getState().close();
  }, [win, channelId]);

  // ⌥M / Alt+M works in the pop-out too.
  useEffect(() => {
    if (!win) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.altKey && !event.metaKey && !event.ctrlKey && event.code === 'KeyM') {
        event.preventDefault();
        void useVoice.getState().toggleMic();
      }
    };
    win.addEventListener('keydown', onKey);
    return () => win.removeEventListener('keydown', onKey);
  }, [win]);

  if (!win || !channelId || !connected) return null;
  const name = channels?.find((c) => c.id === channelId)?.name ?? 'Görüşme';

  return createPortal(
    <div className="flex h-dvh flex-col bg-surface-1 text-fg-1">
      <header className="flex h-11 flex-none items-center gap-2 border-b border-line px-3">
        <span className="size-[7px] flex-none rounded-full bg-green-400" aria-hidden="true" />
        <span className="min-w-0 flex-1 truncate text-sm font-semibold">{name}</span>
        <button
          type="button"
          onClick={() => usePopout.getState().close()}
          className="nc-press flex h-8 items-center gap-1.5 rounded-sm border border-line-strong bg-surface-2 px-2.5 text-xs font-semibold text-fg-1"
        >
          <PictureInPicture2 size={14} aria-hidden="true" />
          Ana pencereye al
        </button>
      </header>
      <CallStage compact />
    </div>,
    win.document.body,
  );
}
